import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, RollbackOutlined } from "@ant-design/icons";
import { Dropdown, Space, Table, Tag } from "antd";
import tagByStatus from "features/requestApproval/components/TagByStatus";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import TableAntd from "components/elements/Table/Table";
import StatusTag from "components/elements/TagCustom/StatusTag";
import { log } from "@antv/g2plot/lib/utils";
import { formatDateTime } from "utils/formatter";

const OvertimeTable = ({
  isLoading = false,
  pagination = {},
  dataSource = [],
  onEdit = () => { },
  onView = () => { },
  onDelete = () => { },
  onStatus = () => { },
  onChange = () => { },
  isEmployee = false,
  isHistory = false
}) => {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);

  // function formatDate(dateString) {
  //   if (!dateString) return;
  //   const date = dayjs(dateString);
  //   return date.format(i18n.language === "en" ? "DD MMM YYYY" : `DD MMMM ${date.year() + 543}`);
  // }
  const formatTime = (hours, minutes, language) => {
    const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    return language === "en" ? formattedTime : `${formattedTime} น.`;
  };

  const showActionBar = isEmployee
    ? roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OVERTIME")
    : (!isHistory &&
      (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OVERTIME") ||
        roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OVERTIME")));

  function readMode(status, record) {
    let items = []
    if (String(status)?.toLowerCase?.() == 'Draft'?.toLowerCase?.()) {
      if (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OVERTIME") && !isEmployee) {
        items.push({
          key: "1",
          onClick: () => onEdit(record),
          label: `${t("action.edit")}`,
          icon: (
            <EditOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
      if (roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OVERTIME") && !isEmployee) {
        items.push({
          key: "2",
          onClick: () => onDelete(record),
          label: `${t("action.delete")}`,
          icon: (
            <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
          ),
        })
      }
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") && !isEmployee) || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OVERTIME"))) {
      items.push({
        key: "3",
        onClick: () => onView(record),
        label: `${t("action.view")}`,
        icon: (
          <EyeOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    if ((roles.includes("ACCESS_MY_DOCUMENT|MY_REQUEST") || (isEmployee && roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OVERTIME"))) && record?.["approveStatusEn"] == 'Approved' && record?.rejectFlow == null) {
      items.push({
        key: "4",
        onClick: () => onView(record, "reject"),
        label: `${t("common.reject")}`,
        icon: (
          <RollbackOutlined style={{ fontSize: "18px", color: "gray" }} />
        ),
      },)
    }
    return items || []
  }


  function formatDate(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
  }

  const columns = [
    {
      title: <div className="text-table">{t('workin_location.label.reqid')}</div>,
      dataIndex: "sequence",
      key: "sequence",
      align: "center",
    },
    isHistory && {
      title: <div className="text-table">{t("workin_location.label.approvalSequence")}</div>,
      dataIndex: "sequenceNumber",
      key: "sequenceNumber",
      render: (_, record, index) => {
        const getApprovalOrder = () => {
          let order = 1;
          if (record.children === null) {
            order = 1;
          } else if (record.children === undefined) {
            order = index + 2;
          } else {
            order = 1;
          }
          return `${t("workin_location.label.approvalNumber")} ${order}`;
        };

        return getApprovalOrder();
      },
    },
    {
      title: <div className="text-table">{t("leave_type.label.create_date")}</div>,
      dataIndex: "createDate",
      key: "createDate",
      render: (_, record) => {
        return record?.createDate ? formatDate(record?.createDate) : "-"
      },
      align: "center"
    },
    {
      title: <div className="text-table" >{t("leave_type.label.start_date")}</div>,
      dataIndex: "startDate",
      key: "startDate",
      render: (_, record) => {
        return record?.startDate ? formatDate(record?.startDate) : "-"
      },
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end_date")}</div>,
      dataIndex: "endDate",
      key: "endDate",
      render: (_, record) => {
        return record?.endDate ? formatDate(record?.endDate) : "-"
      },
      align: "center"
    },

    {
      title: <div className="text-table" >{t("leave_type.label.start-time")}</div>,
      dataIndex: "overtimeString",
      key: "overtimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t("leave_type.label.end-time")}</div>,
      dataIndex: "endDateTimeString",
      key: "endDateTimeString",
      align: "center"
    },
    {
      title: <div className="text-table">{t('collect_time.total_duration')}</div>,
      dataIndex: "totalDuration",
      key: "totalDuration",
      align: "center",
      render: (_, record) => {
        if (record.totalDurationHour === 0) {
          return i18n.language === "en" ? record.totalDurationMinute + " minutes" : record.totalDurationMinute + " นาที"

        } else {
          return i18n.language === "en" ? record.totalDurationHour + " H " + record.totalDurationMinute + " M" : record.totalDurationHour + " ชม." + record.totalDurationMinute + " นาที"
        }
      }
    },
    {
      title: <div className="text-table" >{t("levave_type_action")}</div>,
      dataIndex: "description",
      key: "description",
      align: "center"
    },
    isHistory && {
      title: <div className="text-table">{t('วันที่อนุมัติ')}</div>,
      dataIndex: "approverDate",
      key: "approverDate",
      align: "center",
      render: (_, record) => {
        return record?.approverDate ? formatDateTime(record?.approverDate) : "-"
      }
    },
    isHistory && {
      title: <div className="text-table">{t('request_all.approver')}</div>,
      dataIndex: "approverBy",
      key: "approverBy",
      align: "center",
      render: (_, record) => {
        if (record?.approverBy?.nameAndSurname !== null && record?.approverBy?.nameAndSurnameEn !== null) {
          return i18n.language === 'en' ? record?.approverBy?.nameAndSurnameEn : record?.approverBy?.nameAndSurname
        } else if (record?.approverBy?.name !== null && record?.approverBy?.nameEn) {
          return i18n.language === 'en' ? record?.approverBy?.nameEn : record?.approverBy?.name
        }
        return "-"
      }
    },
    {
      title: <div className="text-table">{t('status.entity')}</div>,
      dataIndex: "status",
      key: "status",
      align: "center",
      render: (text, record) => {
        let language = i18n.language == 'en' ? "En" : ""
        return <StatusTag value={(record?.["approveStatus" + language])} />
      }
    },
    // !isHistory && (roles.includes("UPDATE_MY_DOCUMENT|MY_REQUEST|OVERTIME") || roles.includes("DELETE_MY_DOCUMENT|MY_REQUEST|OVERTIME") ? actionBar() : {})
    showActionBar ? actionBar() : {}
  ].filter(Boolean);

  function actionBar() {
    if (!isEmployee || roles.includes("ACCESS_EMPLOYEE|DOCUMENT|OVERTIME")) {
      return {
        title: "",
        key: "action",
        align: "center",
        render: (_, record) => (
          <Space size="middle">
            <Dropdown
              menu={{
                items: readMode(_.approveStatusEn, record)
              }}
            >
              <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
            </Dropdown>
          </Space>
        ),
      }
    } else {
      return {}
    }
  }

  const processedDataSource = dataSource.map(item => {
    if (Array.isArray(item.children) && item.children.length === 0) {
      return { ...item, children: null };
    }
    return item;
  });

  return (
    <TableAntd
      loading={isLoading}
      pagination={{
        ...pagination,
        showTotal: (total, range) =>
          t("paginate.description")
            .replace("{min}", range[0])
            .replace("{max}", range[1])
            .replace("{total}", total),
      }}
      dataSource={processedDataSource}
      rowKey={(record) => record.id}
      columns={columns}
      onChange={onChange}
    />
  );
};

export default OvertimeTable;
